"use client"
import React, { useState, useEffect, useRef } from 'react';


import DataTableListGenerica from './DataTableListGenerica/DataTableListGenerica'
import FormularioCalificacionRA from './DataTableGenerica/FormularioCalificacionRA';
//import DataTableGenerica from './DataTableGenerica'
import DataTableGenericaCalificacion from './DataTableGenerica/DataTableGenericaCalificacion'
import DataTableListGenericaRaw from './DataTableListGenerica/DataTableListGenericaRaw'

import { connect } from "react-redux";
import dynamic from 'next/dynamic';


import PrimeReact from "primereact/api";

import { Skeleton } from 'primereact/skeleton';
import { Inplace, InplaceDisplay, InplaceContent } from 'primereact/inplace';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from 'primereact/inputtext';
import classNames from 'classnames';
import { Calendar } from 'primereact/calendar';
import { addLocale } from 'primereact/api';
import { OverlayPanel } from 'primereact/overlaypanel';


import { ContenidoPublico } from '../templates/ContenidoPublico';

import { GenericaSistemaService } from '../service/GenericaSistemaService';
import { PlantillaService } from '../service/PlantillaService';

import AuthStorage from '../storage/AuthStorage';
import AuthController from '../controller/AuthController';

import { InputTextarea } from 'primereact/inputtextarea';
import { Editor } from 'primereact/editor';
import Link from 'next/link';

import Document from './DataTableGenerica/Document';

import { getConfigSubdomainDefault, GetCurrentUserDefault } from '../storage/getConfigSubdomainDefault';

import lodash from "lodash";
import crypto from "crypto-js";

import "primereact/resources/primereact.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import "prismjs/themes/prism-coy.css";
import "../assets/demo/flags/flags.css";
import "../assets/demo/Demos.scss";
import "../assets/layout/layout.scss";
import "../App.scss";



const BlocksMedicionRAFromMoodle = (props) => {

    console.log("blockMedicionRA.js");

    const authController = new AuthController();

    const [authStorage, setAuthStorage] = useState(undefined);

    const [dataConfigSubdomain, setDataConfigSubdomain] = useState(getConfigSubdomainDefault);
    let { subdomain, idSuscripcion, idEmpresaInit, idiomaInit } = dataConfigSubdomain;


    const userDetails = authStorage ? authStorage.GetCurrentUser() : GetCurrentUserDefault();
    let { userName, idEmpresa, idioma, sessionGUID, documentoInvitado } = userDetails;


    //const urlFullLogoLoginDefault = "assets/layout/images/logo-login.png";

    //let urlFullLogoLogin = urlLogoLogin ? process.env.NEXT_PUBLIC_URL_API + urlLogoLogin : urlFullLogoLoginDefault;

    //const { user: ContextState, configSubdomain, login } = useContext(AuthProvider);
    //const {isLoginPending,isLoggedIn,loginError, subdomain, userName, idSuscripcion, idEmpresa, idioma } = ContextState;

    //const authService = new AuthService();
    const plantillaService = new PlantillaService();

    const codMenu = "LOGIN";

    const [etiquetasMenu, setEtiquetasMenu] = useState([]);
    const [intentoErrado, setIntentoErrado] = useState(0);
    const [vecesBotonPresionado, setVecesBotonPresionado] = useState(0);

    const [etiquetasModulo, setEtiquetasModulo] = useState([]);

    //const selectedTipoGenericaRef = { tg: "BAS_TERCERO", version: 0, filtroUts: { 'documentoTercero': '__' } };

    const [checked, setChecked] = useState(false);
    const [form, setForm] = useState({
        idSuscripcion: idSuscripcion,
        idioma: idiomaInit,
        idEmpresa: idEmpresaInit,
        subdomain: subdomain,
        userName: 'visit',
        password: ''
    });

    useEffect(() => {

        guidIntento.current = window.crypto.randomUUID();

        const authStorage = new AuthStorage(window.location.pathname);
        let mewdataConfigSubdomain = authStorage.getConfigSubdomain();

        setAuthStorage(authStorage);
        setDataConfigSubdomain(mewdataConfigSubdomain);

        const userDetails = authStorage.GetCurrentUser();
        userName = userDetails.userName;
        idioma = userDetails.idioma;
        idEmpresa = userDetails.idEmpresa;
        sessionGUID = userDetails.sessionGUID
        documentoInvitado = userDetails.documentoInvitado


        subdomain = mewdataConfigSubdomain.subdomain;
        idSuscripcion = mewdataConfigSubdomain.idSuscripcion;
        idEmpresaInit = mewdataConfigSubdomain.idEmpresaInit;
        idiomaInit = mewdataConfigSubdomain.idiomaInit;

        let newForm = {
            idSuscripcion: idSuscripcion,
            idioma: idiomaInit,
            idEmpresa: idEmpresaInit,
            subdomain: subdomain,
            userName: 'visit',
            password: ''
        };
        setForm(newForm);

        //loginUser action makes the request and handles all the neccessary state changes

        let response = authController.loginUser(newForm).then(response => {

            loadDatosBase();

            getPayloadRefQueryParam();

            if (response.userName !== undefined && response.userName !== "") {
                //setEtiquetasModulo([]);
            }

            if (response.userName !== undefined && response.userName !== "") {
                setEtiquetasModulo([]);
            }


        });
        console.log("responseVisit, ", response);


    }, []);


    const loadDatosBase = async () => {
        await plantillaService.getEtiquetasMenuAuth(idEmpresaInit, idiomaInit, codMenu).then(data => {
            console.log("getEtiquetasMenuAuth, ", data);
            setEtiquetasMenu(data);
        });
    }

    function GetTextoEtiqueta(etiqueta) {
        return (etiquetasMenu.filter(et => et.etiqueta === etiqueta).map(et => et.ctiTexto));
    }



    const payLoadRef = useRef(null);

    const getPayloadRefQueryParam = () => {

        if (payLoadRef.current == null && window.location.search !== null) {

            const queryParams = new URLSearchParams(window.location.search);
            let payloadDecoded = queryParams.get("payload") || "";

            if (payloadDecoded !== "") {

                let payloadStr = Buffer.from(payloadDecoded, 'base64') + "";//.toString('ascii');

                const payload = JSON.parse(payloadStr);
                console.log("payload, ", payload);

                // Acá viene la particularidad de CECAR en el shortName del curso
                let newfiltroUts = payload.bodyContentPayload.item.selectedTipoGenerica.filtroUts;

                let splitGrupo = newfiltroUts['codInternoCursoMoodle'].toString().split('_');
                let grupo = splitGrupo[0];  //se supone que es el primero

                if (splitGrupo.length === 0) {
                    grupo = "45326";
                }

                newfiltroUts['grupo'] = grupo;

                //delete newfiltroUts['codInternoCursoMoodle'];
                //console.log("newfiltroUts, ", newfiltroUts);

                let newTg = 'FMT_FORMATO_EVALUACION-RAP_MOODLE'

                payload.bodyContentPayload.item.selectedTipoGenerica.tg = newTg
                payload.bodyContentPayload.item.selectedTipoGenerica.filtroUts = newfiltroUts;


                //paypayload.bodyContentPayload.item.selectedTipoGenerica.filtroUts['codInternoMoodle'] = paypayload.bodyContentPayload.item.selectedTipoGenerica.filtroUts['codInternoMoodle'].split(',')[0];
                //paypayload.bodyContentPayload.item.selectedTipoGenerica.filtroUts['codMoodle']



                payLoadRef.current = { payloadDecoded: payloadDecoded, hash: payload.hash, bodyContentPayload: payload.bodyContentPayload }


                //setSelectedTipoGenerica(undefined);
                //setComodin(prev => prev + 1);
            }

        }

    }

    const LoadEtiquetas = async () => {

        if (etiquetasModulo !== undefined && etiquetasModulo.length === 0) {

            await plantillaService.getEtiquetasModulo(codModulo, idEmpresa, idioma, userName).then(data => {
                setEtiquetasModulo(data);
            });

        }

    }

    useEffect(() => {

        if (userName !== undefined && userName !== "" && etiquetasModulo.length === 0) {
            LoadEtiquetas();
        }

    }, [etiquetasModulo])


    const codModulo = "DATATABLE_GENERICA";

    const genericaSistemaService = new GenericaSistemaService();

    //const etiquetasModulo = props.etiquetasModulo;

    //const selectedTipoGenerica = props.selectedTipoGenerica;

    const [metadataGenericaSistema, setMetadataGenericaSistema] = useState([]);

    const [metadataGenericaSistemaTgOperaciones, setMetadataGenericaSistemaTgOperaciones] = useState([]);

    //const [modoEdicion, setModoEdicion] = useState(false);
    const [modoEdicion, setModoEdicion] = useState(true);

    const metadataGenericaSistemaForm = props.metadataGenericaSistemaForm;
    const genericaSistemaDialog = props.genericaSistemaDialog;

    const genericaSistemaDialogRef = useRef(null);
    const toast = useRef(null);

    const guidIntento = useRef(undefined);

    const _ = lodash;

    let emptyGenericaSistemaInit = {
        idEmpresa: idEmpresa, id: 0, ctiTexto: "", uts: []
    };

    const [emptyGenericaSistema, setEmptyGenericaSistema] = useState(emptyGenericaSistemaInit);


    const prevSelectedTipoGenericaRef = useRef(undefined);


    //const [comodin, setComodin] = useState(0);
    const [selectedTipoGenerica, setSelectedTipoGenerica] = useState(undefined);

    const [genericaSistema, setGenericaSistema] = useState(undefined);




    if (selectedTipoGenerica == undefined && payLoadRef.current !== null && payLoadRef.current.bodyContentPayload !== null) {
        setSelectedTipoGenerica({ ...payLoadRef.current.bodyContentPayload.item.selectedTipoGenerica });
    }
    else if (selectedTipoGenerica == undefined && props.selectedTipoGenerica !== undefined) {
        setSelectedTipoGenerica({ ...props.selectedTipoGenerica });
    }
    else if (props.selectedTipoGenerica !== undefined) {

        let newSelectedTipoGenerica = undefined;

        if (!_.isEqual(props.selectedTipoGenerica.filtroUts, selectedTipoGenerica.filtroUts)) {
            //else if (props.selectedTipoGenerica.filtroUts !== selectedTipoGenerica.filtroUts) {
            newSelectedTipoGenerica = { ...selectedTipoGenerica, version: props.selectedTipoGenerica.version, filtroUts: { ...props.selectedTipoGenerica.filtroUts }, variableRestriccionExterna: { ...props.selectedTipoGenerica.variableRestriccionExterna }, };
            setSelectedTipoGenerica(newSelectedTipoGenerica);
        }
        else if (props.selectedTipoGenerica.variableRestriccionExterna !== undefined
            && !_.isEqual(props.selectedTipoGenerica.variableRestriccionExterna, selectedTipoGenerica.variableRestriccionExterna)) {
            //else if (props.selectedTipoGenerica.filtroUts !== selectedTipoGenerica.filtroUts) {
            newSelectedTipoGenerica = { ...selectedTipoGenerica, version: props.selectedTipoGenerica.version, variableRestriccionExterna: { ...props.selectedTipoGenerica.variableRestriccionExterna }, };
            setSelectedTipoGenerica(newSelectedTipoGenerica);
        }
        else if (props.selectedTipoGenerica.version !== undefined && selectedTipoGenerica.version !== undefined && props.selectedTipoGenerica.version !== selectedTipoGenerica.version) {

            let newSelectedTipoGenerica2 = { ...selectedTipoGenerica, version: props.selectedTipoGenerica.version };
            setSelectedTipoGenerica(newSelectedTipoGenerica2);
        }

    }

    const [submitted, setSubmitted] = useState(false);

    const formatCurrency = (value) => {
        return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    }

    useEffect(() => {

        if ((userName !== undefined && userName !== "" && selectedTipoGenerica !== undefined) && (
            selectedTipoGenerica.tipoOrganizacionContenido === undefined || selectedTipoGenerica.tipoOrganizacionContenido === "FORM_CALIFICACION")) {

            let prevselectedTipoGenerica = { ...selectedTipoGenerica }
            let isEmpty = _.isEqual({}, selectedTipoGenerica);

            if (prevSelectedTipoGenericaRef.current === undefined && selectedTipoGenerica !== undefined && !isEmpty) {
                LoadDatosGenerica(selectedTipoGenerica.tg, idEmpresa, idioma, userName);
                prevselectedTipoGenerica["intentoMetadata"] = 0;
            }
            else if (prevSelectedTipoGenericaRef.current !== undefined && selectedTipoGenerica !== undefined && !isEmpty) {

                if (prevSelectedTipoGenericaRef.current.tg !== selectedTipoGenerica.tg) {
                    LoadDatosGenerica(selectedTipoGenerica.tg, idEmpresa, idioma, userName);
                    prevselectedTipoGenerica["intentoMetadata"] = 0;
                }
                else if (metadataGenericaSistema.length === 0 && (prevSelectedTipoGenericaRef.current.intentoMetadata === undefined || prevSelectedTipoGenericaRef.current.intentoMetadata < 1)) {
                    LoadDatosGenerica(selectedTipoGenerica.tg, idEmpresa, idioma, userName);
                    prevselectedTipoGenerica["intentoMetadata"] = prevSelectedTipoGenericaRef.current.intentoMetadata ? prevSelectedTipoGenericaRef.current.intentoMetadata + 1 : 1;
                }
                else {
                    //console.log("setLazyParams");
                    //setLazyParams({ ...lazyParams });
                }

            }

            prevSelectedTipoGenericaRef.current = prevselectedTipoGenerica;

        }

    }, [selectedTipoGenerica])

    const createHeaderGenerica = (objecto) => {

        let headers = "";

        //Object.keys(params).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k])).join('&')

        objecto.forEach(function (meta, indice, array) {
            if (indice > 0) {
                headers += ',';
            }
            else {
                headers += '{';
            }

            switch (meta.tipoDato) {
                case "string": headers += `"${meta.campo}":{ "value": "", "matchMode": "contains", "ref": null }`; break;
                default: headers += `"${meta.campo}":{ "value": "", "matchMode": "equals","ref": null }`; break;
            }

        });

        headers += '}';



        return (JSON.parse('' + headers + ''));
    }


    const LoadDatosGenerica = async (_tg, idEmpresa, idioma, userName) => {

        //lazyParamInit.filters = createHeaderGenerica([{ "campo": "" }]);

        if (selectedTipoGenerica.tg !== "") {

            if ((selectedTipoGenerica.operaciones === undefined || selectedTipoGenerica.operaciones.length === 0)) {

                //console.log("GetTipoGenericaSistemaByTg - Datatablegener, ", selectedTipoGenerica)
                genericaSistemaService.GetTipoGenericaSistemaByTg({ lazyEvent: JSON.stringify("") }, idEmpresa, idioma, userName, selectedTipoGenerica.tg).then(data => {

                    let newSelectedTipoGenerica = data.data;

                    if (selectedTipoGenerica.filtroUts !== undefined) {
                        newSelectedTipoGenerica.filtroUts = { ...selectedTipoGenerica.filtroUts };
                        newSelectedTipoGenerica.ctiTextoFiltroUts = selectedTipoGenerica.ctiTextoFiltroUts
                    }
                    if (selectedTipoGenerica.variableRestriccionExterna !== undefined) {
                        newSelectedTipoGenerica.variableRestriccionExterna = { ...selectedTipoGenerica.variableRestriccionExterna };
                    }
                    else {
                        newSelectedTipoGenerica.variableRestriccionExterna = {};
                    }

                    if (selectedTipoGenerica.operacionesCampos == undefined || !_.isEqual(selectedTipoGenerica.operacionesCampos, data.data.operacionesCampos)) {
                        newSelectedTipoGenerica.operacionesCampos = [...data.data.operacionesCampos];
                    }
                    if (selectedTipoGenerica.version !== undefined) {
                        newSelectedTipoGenerica.version = selectedTipoGenerica.version;
                    }

                    setSelectedTipoGenerica(newSelectedTipoGenerica);

                });
            }

            //else{}

            if (selectedTipoGenerica.operaciones !== undefined && metadataGenericaSistema.length === 0) {
                console.log("entro");
                //else if (metadataGenericaSistema.length === 0 && selectedTipoGenerica.operaciones !== undefined) {

                await genericaSistemaService.getMetadataGenericasConOperacionesDeTg(_tg, idEmpresa, idioma, userName).then(data => {


                    let columnaIdentificadorOculta = "tg";
                    let prefijo = '000000';
                    let TamSufijo = 4;
                    /*data = data.sort(function (a, b) {
                        let a1 = a.tg + '-' + (prefijo + a.orden).substring((prefijo + a.orden).length - TamSufijo) + '-' + a.campoOrigen + '-' + a.tipoDato;
                        let b1 = a.tg + '-' + (prefijo + b.orden).substring((prefijo + b.orden).length - TamSufijo) + '-' + b.campoOrigen + '-' + b.tipoDato;
                        return a1 > b1 ? 1 : a1 < b1 ? -1 : 0;
                    });*/

                    data = data.map(x => ({ ...x, formRef: null, columnRef: null, mensajeError: "" }));

                    let _metadataGenericaSistemaTgOperaciones = [...data];
                    //let _metadataGenericaSistemaTgOperaciones = data.map(x => x);
                    //setMetadataGenericaSistemaTgOperaciones(_metadataGenericaSistemaTgOperaciones);

                    data = data.filter(col => col.tg === _tg);

                    let metadataImprimible = data.filter(col => col.ctiConfigurado >= 0 && col.esImprimible > 0);

                    let dataForm = metadataImprimible;
                    let dataRef = data.map(x => ({ campo: x.campo, tipoDato: x.tipoDato, tg: x.tg, columnFiltroRef: null }));

                    if (dataRef.length > 0) {

                        //setEmptyGenericaSistema(crearNewEmptyGenerica(dataForm));



                        //lazyParamInit.filters = createHeaderGenerica(dataForm);
                        //lazyParamInit.filters = {};

                        //let newLazyParamInit = Object.assign({}, lazyParamInit);
                        //console.log("lazyParamInit, ", lazyParamInit);

                        //setMetadataGenericaSistema(data);

                        /*
                        setMetadataGenericaSistemaRef([...dataRef]);
                        setMetadataGenericaFormulario([...dataForm]);
                        setMetadataGenericaFormularioFactura([...dataForm]);

                        setSelectedTipoGenericaFormulario({ ...selectedTipoGenerica });
                        setSelectedTipoGenericaFormularioFactura({ ...selectedTipoGenerica });

                        */

                        if (selectedTipoGenerica.operaciones) {
                            let _canEditRow = selectedTipoGenerica.operaciones === undefined ? false : selectedTipoGenerica.operaciones.some(x => x.tg === selectedTipoGenerica.tg && x.tipoOperacion === "EDIT_ROW");
                            //setCanEditRow( (props.canEditRow | true) && selectedTipoGenerica.operaciones === undefined ? false : selectedTipoGenerica.operaciones.some(x => x.tg === selectedTipoGenerica.tg && x.tipoOperacion === "EDIT_ROW"));
                        }

                        setMetadataGenericaSistema(_metadataGenericaSistemaTgOperaciones.filter(x => x.tg === _tg && x.ctiConfigurado >= 0 && (x.esImprimible > 0 || x.esSoloLectura > 0)));

                        setMetadataGenericaSistemaTgOperaciones(_metadataGenericaSistemaTgOperaciones);

                        let newGenerica = crearNewEmptyGenerica(dataForm);
                        setGenericaSistema(newGenerica);

                        //setLazyParams({ ...newLazyParamInit });
                        //lazyParamsInitSelected.current = newLazyParamInit;

                    }

                });





            }
        }

    }

    const crearNewEmptyGenerica = (metadata) => {

        let item = {}

        item['id'] = 0;
        item['idEmpresa'] = idEmpresa;
        item['idioma'] = "ES";
        item['tg'] = metadata.length > 0 ? metadata[0].tg : "";

        item['uts'] = {};

        metadata.forEach(x => {
            if (x.campo === "tg")
                item[`${x.campo}`] = x.tg;

            else {

                let newVal = "";
                if (x.tipoDato === "date")
                    newVal = 0;
                else if (x.tipoDato === "int") newVal = 0;
                else if (x.tipoDato === "double") newVal = 0.0;
                else if (x.tipoDato === "money") newVal = 0;
                else if (x.tipoDato === "boolean") newVal = false;
                else newVal = "";

                if (selectedTipoGenerica.filtroUts !== undefined) {

                    if (selectedTipoGenerica.filtroUts[x.campo] !== undefined && selectedTipoGenerica.filtroUts[x.campo] !== "") {
                        newVal = selectedTipoGenerica.filtroUts[x.campo];
                        item['uts'][`${x.campo}`] = newVal
                    }


                    //console.log("newVal,", x.campo,newVal);
                    //console.log("selectedTipoGenerica,", selectedTipoGenerica);
                }



                //item['uts'] = { ...item['uts'], [`${x.campo}`]: newVal }

            }
        });

        return item;

    }

    const genericaSistemaDialogFooter = (
        <>
            <Button label="Cancelar" icon="pi pi-times" className="p-button-text" // onClick={props.onHideForm} 
            />
            <Button label="Guardar" icon="pi pi-check" className="p-button-text" // onClick={savegenericaSistema} 
            />
        </>
    );

    const onClickEditarFormularioFactura = async () => {

    }

    const FormularioFacturaHeader = () => {

        if (!modoEdicion) {

            return (<><span>asdfasfsf</span></>);

        }
        else {
            return (<><span>asdfasfsf</span></>);
        }
    }

    const onChangeDataInterno = (e, metadataRef) => {
    }

    const onSaveSuccessfulFormulario = (_genericaSistema, idOriginal, genericasSistemaAffect) => {

    }


    //if (!genericaSistemaDialog || etiquetasModulo.length === 0)
    if (idEmpresa <= 0 || userName === undefined || userName === ""
        //|| genericaSistemaDialog === false 
        || etiquetasModulo.length === 0
        || selectedTipoGenerica === undefined || selectedTipoGenerica.operaciones === undefined
        || (selectedTipoGenerica.tipoOrganizacionContenido !== "FORM_CALIFICACION")
        //|| metadataGenericaSistemaTgOperaciones.length === 0        
        //|| genericaSistema === undefined

        //|| genericasSistema_FORMULARIO_STRUCT_CONSOLIDADO === null || genericasSistema_FORMULARIO_STRUCT_NOTAPADRE === null || genericasSistema_FORMULARIO_STRUCT_DETALLE === null

    )

        return (<></>);

    else if (idEmpresa <= 0 || userName === undefined || userName === ""
        //|| genericaSistemaDialog === false 
        || etiquetasModulo.length === 0
        || selectedTipoGenerica === undefined || selectedTipoGenerica.operaciones === undefined
        || (selectedTipoGenerica.tipoOrganizacionContenido !== "FORM_CALIFICACION")
        || metadataGenericaSistemaTgOperaciones.length === 0
        || genericaSistema === undefined

        //|| genericasSistema_FORMULARIO_STRUCT_CONSOLIDADO === null || genericasSistema_FORMULARIO_STRUCT_NOTAPADRE === null || genericasSistema_FORMULARIO_STRUCT_DETALLE === null

    )

        return (<></>);

    else {
        return (
            <>
                <FormularioCalificacionRA
                    //ref={formFacturaRef} //genericaSistemaDialog={genericaSistemaDialogFormularioFactura} 
                    genericaSistemaDialog={true}
                    genericaSistema={genericaSistema}
                    //metadataGenericaSistemaForm={metadataGenericaFormularioFactura}
                    etiquetasModulo={etiquetasModulo}
                    selectedTipoGenerica={selectedTipoGenerica}
                    //onHideForm={hideDialog} 
                    onSaveSuccessful={onSaveSuccessfulFormulario}
                ></FormularioCalificacionRA>
            </>
        );
    }

}

/*const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname;
};
 
export default React.memo(BlocksLogin, comparisonFn);*/

//export default BlocksMedicionRAFromMoodle;
export default dynamic(() => Promise.resolve(connect(null)(BlocksMedicionRAFromMoodle)), { ssr: false });